<template>
  <div class="launchpack-delivery">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"
    >
      <div slot="week" class="flex-align">
        <div>최근</div>
        <div style="margin:0 6px">
          <span class="select">
          <select @change="selectWeek" v-model="filtered.week">
             <option v-for="(week,idx) in weekList"
                     :key="'week-'+idx"
                     :value="week">{{ week }}</option>
          </select>
        </span>
        </div>
        <div>주</div>
      </div>
      <div slot="partner" v-if="$store.getters.mode!=='partner'">
        <lp-adm-drop-input :data.sync="partners"
                           @onSelect="selectPartnerFilter"
                           placeholder="검색 후 선택"
                           listAlign="left"
                           width="250px"
                           style="margin-top:12px;"></lp-adm-drop-input>
      </div>
    </admin-filter>

    <div class="box">
      <admin-box-item title="매출 현황">
        <div class="flex-align" style="width:600px;">
          <div class="sales-situation-box" style="background-color:#f5f5f5;width:40%">
            <div>총 매출 금액</div>
            <div>{{ total_price - refund_price | currency }}</div>
          </div>
          <div class="sales-situation-box" style="width:30%;">
            <div>총 결제 금액</div>
            <div>{{ total_price | currency }}</div>
          </div>
          <div class="sales-situation-box" style="width:30%;">
            <div>환불 금액</div>
            <div>{{ refund_price | currency }}</div>
          </div>
        </div>
      </admin-box-item>
    </div>

    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @check="clickCheckBox"
                 :table_width="1100"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <td slot="date" slot-scope="props">{{ props.item.date }}</td>
      <td slot="order_count" slot-scope="props">{{ props.item.order_count }}</td>
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>
      <td slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</td>
      <td slot="coupon_price" slot-scope="props">{{ props.item.coupon_price | currency }}</td>
      <td slot="point" slot-scope="props">{{ props.item.point | currency }}</td>
      <td slot="delivery_cost" slot-scope="props">{{ props.item.delivery_cost | currency }}</td>
      <td slot="total_price" slot-scope="props">{{ props.item.total_price | currency }}</td>
      <td slot="refund_price" slot-scope="props">{{ props.item.refund_price | currency }}</td>
      <td slot="sales_price" slot-scope="props">{{ (props.item.total_price - props.item.refund_price) | currency }}</td>

    </order-table>

  </div>
</template>

<script>
  import MartMixin from "@/mixins/MartMixin"
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";

  export default {
    name: 'MartOrderStatisticsWeek',
    components: {LpAdmDropInput},
    mixins: [
      MartMixin
    ],
    data () {
      return {
        total_price: 0,
        refund_price: 0,
        weekList: []
      }
    },
    watch: {

    },
    created() {
      let weekList = [];
      for(let i=2; i<53; i++) {
        weekList.push(i);
      }
      this.weekList = weekList;
      this.init();

      this.$axios.get('public/service/internal-plugin')
        .then(res => {
          if (res.status === 200) {

            let plugin = res.data.internal_plugin;

            if(plugin.indexOf('point_coupon')>-1) {
              let coupon_price = find(this.tableData, 'eng_name', 'coupon_price');
              let point_price = find(this.tableData, 'eng_name', 'point_price');
              if(!coupon_price && !point_price) {
                let idx = this.tableData.findIndex(item => item.eng_name === 'discount_price');
                this.tableData.splice(idx+1, 0, {
                  eng_name: 'coupon_price',
                  ko_name: '쿠폰 할인',
                  width: '120px'
                });
                this.tableData.splice(idx+2, 0, {
                  eng_name: 'point',
                  ko_name: '적립금 사용',
                  width: '120px'
                });
              }
            }
          }
        });

    },
    methods: {
      async init() {
        await this.initializing('order_statistics_week', 'mart/order/statistics/week');
        await this.getSales();
      },
      async getDataFromServer() {
        await this.getData();
        await this.getSales();
      },
      getSales() {
        this.$axios.get(this.getUrl('mart/order/sales/week'), {
          params: this.filtered
        }).then(res => {
          this.total_price = res.data.total_price;
          this.refund_price = res.data.refund_price;
        })
      },
      selectPartnerFilter(res) {
        this.filtered.partner_id = res.value;
        this.getDataFromServer();
      },
      selectWeek(e) {
        this.filtered.week = e.target.value;
        this.getDataFromServer();
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .launchpack-delivery td
    border 1px solid #dbdbdb

  .delivery-info
    position absolute
    left -170px
    top 38px
    background #eee
    z-index 10
    padding 8px
    width 240px

  .delivery-info
    display none

  .delivery-section:hover .delivery-info
    display block

  .sales-situation-box
    text-align center
    border 2px solid #ddd
    color #363636
    border-right 0

  .sales-situation-box:last-child
    border-right 2px solid #ddd

  .sales-situation-box > div:first-child
    border-bottom 2px solid #ddd

  .sales-situation-box > div
    padding 9.5px

  .sales-situation-box > div:last-child
    font-weight bold
    font-size 15px
</style>
